module.exports = __webpack_public_path__ + "img/training_mix8.e20e9f6a.jpg";